export default [
  {
      path: '/measurements',
      name: 'measurements',
      meta: {
          access: 'measurementsView'
      },
      component: () => import('@/views/Measurements/Measurements')
  },
  {
    path: '/measurements/history',
    name: 'measurements-history',
    meta: {
      access: 'measurementsView'
    },
    component: () => import('@/views/Measurements/History/History')
  },
  {
    path: '/measurements/history/:id',
    name: 'measurements-history-detail',
    meta: {
      access: 'measurementsView'
    },
    component: () => import('@/views/Measurements/History/SubPage/Result')
  },
  {
    path: '/measurements/brake/test',
    name: 'measurements-brake-test',
    meta: {
      access: 'measurementsView'
    },
    component: () => import('@/views/Measurements/Brake')
  },
  {
    path: '/measurements/brake/stands',
    name: 'measurements-brake-stands',
    meta: {
      access: 'measurementsView'
    },
    component: () => import('@/views/Measurements/Stands/Stands')
  },
  {
    path: '/measurements/brake/stands/:id',
    name: 'measurements-brake-stands-detail',
    meta: {
      access: 'measurementsView'
    },
    component: () => import('@/views/Measurements/Stands/SubPage/Stand')
  },
  {
    path: '/measurements/brake/calibration',
    name: 'measurements-brake-calibration',
    meta: {
      access: 'measurementsView'
    },
    component: () => import('@/views/Measurements/Measurement/Brake/Calibration')
  },
  {
    path: '/measurements/gas-analyzer/test',
    name: 'measurements-gas-analyzer-test',
    meta: {
      access: 'measurementsView'
    },
    component: () => import('@/views/Measurements/Gas')
  },
  {
    path: '/measurements/smoke/test',
    name: 'measurements-smoke-test',
    meta: {
      access: 'measurementsView'
    },
    component: () => import('@/views/Measurements/Smoke')
  },
  {
    path: '/measurements/light-transmission/test',
    name: 'measurements-light-transmission-test',
    meta: {
      access: 'measurementsView'
    },
    component: () => import('@/views/Measurements/LightTransmission')
  },
  {
    path: '/measurements/light/test',
    name: 'measurements-light-test',
    meta: {
      access: 'measurementsView'
    },
    component: () => import('@/views/Measurements/Light')
  },
  {
    path: '/measurements/noise/test',
    name: 'measurements-noise-test',
    meta: {
      access: 'measurementsView'
    },
    component: () => import('@/views/Measurements/Noise')
  }
]
